import HomePageShow from "../components/homepage/Show";

export default [
  { name: 'HomePage', path: '/', component: HomePageShow, meta: {  showHeaderBanner: true, showSponsors: true, isHomepage: true }}
]
